import axios from 'axios';

import { message } from 'antd';



// API 基础配置 - 从环境变量读取，默认使用生产环境地址

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.netstar.org.cn';



// AI 编排 Orchestrator - separate axios instance



export const AI_ORCH_BASE = import.meta.env.VITE_AI_ORCHESTRATOR_URL || 'https://orchestrator.openyc.vip';



const orchApi = axios.create({

  baseURL: AI_ORCH_BASE + '/v1/admin',

  timeout: 30000,

  headers: { 'Content-Type': 'application/json' },

});



const orchRunApi = axios.create({

  baseURL: AI_ORCH_BASE + '/v1/orchestrate',

  timeout: 60000,

  headers: { 'Content-Type': 'application/json' },

});



// 创建 axios 实例

const api = axios.create({

  baseURL: API_BASE_URL,

  timeout: 30000,

  headers: {

    'Content-Type': 'application/json',

  },

});



// 请求拦截器

api.interceptors.request.use(

  (config) => {

    const token = localStorage.getItem('admin_token');

    if (token) {

      config.headers.Authorization = `Bearer ${token}`;

    }

    return config;

  },

  (error) => {

    return Promise.reject(error);

  }

);



// 响应拦截器

api.interceptors.response.use(

  (response) => {

    return response.data;

  },

  (error) => {

    const { response, config } = error;

    

    // 登录接口特殊处理 - 不显示"登录过期"提示

    const isLoginRequest = config?.url?.includes('/api/admin/auth/login');

    

    if (response) {

      switch (response.status) {

        case 401:

          // 登录接口的 401 是凭据错误，不是登录过期

          if (!isLoginRequest) {

            message.error('登录已过期，请重新登录');

            localStorage.removeItem('admin_token');

            localStorage.removeItem('admin_user');

            window.location.href = '/login';

          }

          break;

        case 403:

          message.error('没有权限执行此操作');

          break;

        case 404:

          message.error('请求的资源不存在');

          break;

        case 500:

          message.error('服务器错误，请稍后重试');

          break;

        default:

          message.error(response.data?.message || '请求失败');

      }

    } else {

      message.error('网络错误，请检查网络连接');

    }

    

    return Promise.reject(error);

  }

);



// ==================== 认证相关 ====================

export const authApi = {

  login: (data) => api.post('/api/admin/auth/login', data),

  logout: () => api.post('/api/admin/auth/logout'),

  getProfile: () => api.get('/api/admin/auth/profile'),

  updatePassword: (data) => api.put('/api/admin/auth/password', data),

};



// ==================== 仪表盘统计 ====================

export const dashboardApi = {

  getStats: () => api.get('/api/admin/dashboard/stats'),

  getUserTrend: (days = 7) => api.get(`/api/admin/dashboard/user-trend?days=${days}`),

  getActiveUsers: () => api.get('/api/admin/dashboard/active-users'),

  getAiUsage: (days = 7) => api.get(`/api/admin/dashboard/ai-usage?days=${days}`),

  getRevenue: (days = 30) => api.get(`/api/admin/dashboard/revenue?days=${days}`),

};



// ==================== 用户管理 ====================

export const userApi = {

  getList: (params) => api.get('/api/admin/users', { params }),

  getDetail: (id) => api.get(`/api/admin/users/${id}`),

  update: (id, data) => api.put(`/api/admin/users/${id}`, data),

  ban: (id, reason) => api.post(`/api/admin/users/${id}/ban`, { reason }),

  unban: (id) => api.post(`/api/admin/users/${id}/unban`),

  delete: (id) => api.delete(`/api/admin/users/${id}`),

  getFriends: (id) => api.get(`/api/admin/users/${id}/friends`),

  getGroups: (id) => api.get(`/api/admin/users/${id}/groups`),

  getChats: (id, params) => api.get(`/api/admin/users/${id}/chats`, { params }),

  exportCsv: (params) => api.get('/api/admin/users/export', { params, responseType: 'blob' }),

};



// ==================== AI 分身管理 ====================

export const avatarApi = {

  getList: (params) => api.get('/api/admin/avatars', { params }),

  getDetail: (id) => api.get(`/api/admin/avatars/${id}`),

  create: (data) => api.post('/api/admin/avatars', data),

  update: (id, data) => api.put(`/api/admin/avatars/${id}`, data),

  delete: (id) => api.delete(`/api/admin/avatars/${id}`),

  getConversations: (id, params) => api.get(`/api/admin/avatars/${id}/conversations`, { params }),

  getUserAvatars: (userId) => api.get(`/api/admin/users/${userId}/avatars`),

};



// ==================== 内容管理 (Moments/消息) ====================

export const contentApi = {

  // Moments 管理

  getMoments: (params) => api.get('/api/admin/moments', { params }),

  getMomentDetail: (id) => api.get(`/api/admin/moments/${id}`),

  deleteMoment: (id) => api.delete(`/api/admin/moments/${id}`),

  reviewMoment: (id, status) => api.post(`/api/admin/moments/${id}/review`, { status }),

  

  // 消息监控

  getMessages: (params) => api.get('/api/admin/messages', { params }),

  getMessageDetail: (id) => api.get(`/api/admin/messages/${id}`),

  deleteMessage: (id) => api.delete(`/api/admin/messages/${id}`),

  

  // 举报处理

  getReports: (params) => api.get('/api/admin/reports', { params }),

  handleReport: (id, data) => api.post(`/api/admin/reports/${id}/handle`, data),

};



// ==================== 群组管理 ====================

export const groupApi = {

  getList: (params) => api.get('/api/admin/groups', { params }),

  getDetail: (id) => api.get(`/api/admin/groups/${id}`),

  update: (id, data) => api.put(`/api/admin/groups/${id}`, data),

  dissolve: (id) => api.delete(`/api/admin/groups/${id}`),

  getMembers: (id) => api.get(`/api/admin/groups/${id}/members`),

  removeMember: (groupId, memberId) => api.delete(`/api/admin/groups/${groupId}/members/${memberId}`),

  getChats: (id, params) => api.get(`/api/admin/groups/${id}/chats`, { params }),

};



// ==================== 订阅管理 ====================

export const subscriptionApi = {

  // 套餐管理

  getPlans: () => api.get('/api/admin/subscriptions/plans'),

  createPlan: (data) => api.post('/api/admin/subscriptions/plans', data),

  updatePlan: (id, data) => api.put(`/api/admin/subscriptions/plans/${id}`, data),

  deletePlan: (id) => api.delete(`/api/admin/subscriptions/plans/${id}`),

  

  // 订单管理

  getOrders: (params) => api.get('/api/admin/subscriptions/orders', { params }),

  getOrderDetail: (id) => api.get(`/api/admin/subscriptions/orders/${id}`),

  refund: (id, reason) => api.post(`/api/admin/subscriptions/orders/${id}/refund`, { reason }),

  

  // 用户订阅

  getUserSubscriptions: (params) => api.get('/api/admin/subscriptions/users', { params }),

  grantSubscription: (userId, data) => api.post(`/api/admin/subscriptions/grant`, { userId, ...data }),

};



// ==================== 系统配置 ====================

export const settingsApi = {

  getAll: () => api.get('/api/admin/settings'),

  update: (data) => api.put('/api/admin/settings', data),

  

  // 敏感词管理

  getSensitiveWords: (params) => api.get('/api/admin/settings/sensitive-words', { params }),

  addSensitiveWord: (word) => api.post('/api/admin/settings/sensitive-words', { word }),

  deleteSensitiveWord: (id) => api.delete(`/api/admin/settings/sensitive-words/${id}`),

  batchImportWords: (words) => api.post('/api/admin/settings/sensitive-words/batch', { words }),

  

  // AI 配置

  getAiConfig: () => api.get('/api/admin/settings/ai'),

  updateAiConfig: (data) => api.put('/api/admin/settings/ai', data),

};



// ==================== 系统日志 ====================

export const logApi = {

  getAccessLogs: (params) => api.get('/api/admin/logs/access', { params }),

  getErrorLogs: (params) => api.get('/api/admin/logs/error', { params }),

  getOperationLogs: (params) => api.get('/api/admin/logs/operation', { params }),

  getLoginLogs: (params) => api.get('/api/admin/logs/login', { params }),

};



// ==================== 通知推送 ====================

export const notificationApi = {

  sendAnnouncement: (data) => api.post('/api/admin/notifications/announcement', data),

  sendToUsers: (data) => api.post('/api/admin/notifications/send', data),

  getHistory: (params) => api.get('/api/admin/notifications/history', { params }),

};



export const aiOrchestrationApi = {

  getOrchestratorHealth: () => axios.get(`${AI_ORCH_BASE}/health`, { timeout: 10000 }).then((res) => res.data),

  getScenarios: () => orchApi.get('/scenarios'),

  getScenarioDetail: (key) => orchApi.get(`/scenarios/${key}/detail`),

  getPrompts: () => orchApi.get('/prompts'),

  createPrompt: (data) => orchApi.post('/prompts', data),

  updatePrompt: (id, data) => orchApi.put(`/prompts/${id}`, data),

  publishPrompt: (id, data) => orchApi.post(`/prompts/${id}/publish`, data),

  getPromptVersions: (id) => orchApi.get(`/prompts/${id}/versions`),

  getModels: () => orchApi.get('/models'),

  createModel: (data) => orchApi.post('/models', data),

  updateModel: (id, data) => orchApi.put(`/models/${id}`, data),

  deleteModel: (id) => orchApi.delete(`/models/${id}`),

  getProviders: () => orchApi.get('/providers'),

  createProvider: (data) => orchApi.post('/providers', data),

  updateProvider: (providerKey, data) => orchApi.put(`/providers/${providerKey}`, data),

  deleteProvider: (providerKey) => orchApi.delete(`/providers/${providerKey}`),

  getRoutes: () => orchApi.get('/routes'),

  createRoute: (data) => orchApi.post('/routes', data),

  updateRoute: (id, data) => orchApi.put(`/routes/${id}`, data),

  getSkills: () => orchApi.get('/skills'),

  createSkill: (data) => orchApi.post('/skills', data),

  updateSkill: (id, data) => orchApi.put(`/skills/${id}`, data),

  getPolicies: () => orchApi.get('/policies'),

  createPolicy: (data) => orchApi.post('/policies', data),

  updatePolicy: (id, data) => orchApi.put(`/policies/${id}`, data),

  getContextBundles: () => orchApi.get('/context-bundles'),

  createContextBundle: (data) => orchApi.post('/context-bundles', data),

  updateContextBundle: (id, data) => orchApi.put(`/context-bundles/${id}`, data),

  getExperiments: () => orchApi.get('/experiments'),

  createExperiment: (data) => orchApi.post('/experiments', data),

  updateExperiment: (id, data) => orchApi.put(`/experiments/${id}`, data),

  getTraces: (limit = 100, filters = {}) => {

    const params = new URLSearchParams({ limit: String(limit) });

    if (filters.scenario) params.set('scenario', filters.scenario);

    if (filters.userId) params.set('userId', filters.userId);

    return orchApi.get(`/traces?${params}`);

  },

  getTrace: (traceId) => orchApi.get(`/traces/${traceId}`),

  getShadowAudits: (limit = 100, severity = null) => {

    const params = `limit=${limit}${severity ? `&severity=${severity}` : ''}`;

    return orchApi.get(`/shadow-audits?${params}`);

  },

  runPlayground: (data) => orchRunApi.post('/playground/run', data),

  dryRunPlayground: (data) => orchRunApi.post('/playground/dry-run', data),

  getPolicyRules: (bundleId) => orchApi.get(`/policies/${bundleId}/rules`),

  createPolicyRule: (bundleId, data) => orchApi.post(`/policies/${bundleId}/rules`, data),

  updatePolicyRule: (ruleId, data) => orchApi.put(`/policies/rules/${ruleId}`, data),

  deletePolicyRule: (ruleId) => orchApi.delete(`/policies/rules/${ruleId}`),

  getContextBundleItems: (bundleId) => orchApi.get(`/context-bundles/${bundleId}/items`),

  createContextBundleItem: (bundleId, data) => orchApi.post(`/context-bundles/${bundleId}/items`, data),

  updateContextBundleItem: (itemId, data) => orchApi.put(`/context-bundles/items/${itemId}`, data),

  deleteContextBundleItem: (itemId) => orchApi.delete(`/context-bundles/items/${itemId}`),

  getSkillBundleItems: (bundleId) => orchApi.get(`/skills/${bundleId}/items`),

  createSkillBundleItem: (bundleId, data) => orchApi.post(`/skills/${bundleId}/items`, data),

  updateSkillBundleItem: (itemId, data) => orchApi.put(`/skills/items/${itemId}`, data),

  deleteSkillBundleItem: (itemId) => orchApi.delete(`/skills/items/${itemId}`),

  activatePromptVersion: (templateId, versionId) => orchApi.put(`/prompts/${templateId}/versions/${versionId}/activate`),

  getPsychTaxonomy: (category = '') => orchApi.get(`/psych/taxonomy${category ? `?category=${encodeURIComponent(category)}` : ''}`),

  upsertPsychTaxonomy: (data) => orchApi.post('/psych/taxonomy', data),

  getPsychTranslationRules: (traitType = '') => orchApi.get(`/psych/translation-rules${traitType ? `?trait_type=${encodeURIComponent(traitType)}` : ''}`),

  createPsychTranslationRule: (data) => orchApi.post('/psych/translation-rules', data),

  updatePsychTranslationRule: (ruleId, data) => orchApi.put(`/psych/translation-rules/${ruleId}`, data),

  getPsychSceneBases: () => orchApi.get('/psych/scene-bases'),

  upsertPsychSceneBase: (sceneKey, data) => orchApi.post(`/psych/scene-bases/${encodeURIComponent(sceneKey)}`, data),

  getPsychQuestionSets: () => orchApi.get('/psych/question-sets'),

  upsertPsychQuestionSet: (setKey, data) => orchApi.post(`/psych/question-sets/${encodeURIComponent(setKey)}`, data),

  getPsychSignals: (params = {}) => orchApi.get('/psych/signals', { params }),

  getPsychTrainingSamples: (params = {}) => orchApi.get('/psych/training-samples', { params }),

  getPsychTrainingBatches: (params = {}) => orchApi.get('/psych/training-batches', { params }),

  createPsychTrainingBatch: (data) => orchApi.post('/psych/training-batches', data),

  exportPsychTrainingBatch: (batchKey) => orchApi.get(`/psych/training-batches/${encodeURIComponent(batchKey)}/export`),

  getPsychTrainingRuns: (params = {}) => orchApi.get('/psych/training-runs', { params }),

  createPsychTrainingRun: (data) => orchApi.post('/psych/training-runs', data),

  updatePsychTrainingRun: (runKey, data) => orchApi.patch(`/psych/training-runs/${encodeURIComponent(runKey)}`, data),

  exportPsychTrainingRunPackage: (runKey) => orchApi.get(`/psych/training-runs/${encodeURIComponent(runKey)}/package`),

  submitPsychTrainingRun: (runKey) => orchApi.post(`/psych/training-runs/${encodeURIComponent(runKey)}/submit`),

  recordPsychEvent: (data) => orchApi.post('/psych/event', data),

  getPsychProfile: (userId) => orchApi.get(`/psych/profile/${encodeURIComponent(userId)}`),

  upsertPsychProfile: (userId, data) => orchApi.post(`/psych/profile/${encodeURIComponent(userId)}`, data),

  getProviderSecrets: () => api.get('/api/admin/ai/provider-secrets'),

  upsertProviderSecret: (providerKey, data) => api.put(`/api/admin/ai/provider-secrets/${encodeURIComponent(providerKey)}`, data),

  deleteProviderSecret: (providerKey) => api.delete(`/api/admin/ai/provider-secrets/${encodeURIComponent(providerKey)}`),

  getTrustRules: () => orchApi.get('/trust/rules'),

  upsertTrustRule: (data) => orchApi.post('/trust/rules', data),

  getTrustUser: (userId) => orchApi.get(`/trust/user/${encodeURIComponent(userId)}`),

  upsertTrustUser: (userId, data) => orchApi.post(`/trust/user/${encodeURIComponent(userId)}`, data),

  getTrustScenes: (userId) => orchApi.get(`/trust/scenes/${encodeURIComponent(userId)}`),

  getTrustEvents: (userId, params = {}) => api.get(`/api/admin/ai/trust/events/${encodeURIComponent(userId)}`, { params }),

  recomputeTrustUser: (userId) => api.post(`/api/admin/ai/trust/recompute/${encodeURIComponent(userId)}`),

  getRuntimePsychProfile: (userId, params = {}) => api.get(`/api/admin/ai/psych/runtime-profile/${encodeURIComponent(userId)}`, { params }),

  recomputePsychProfile: (userId, data = {}) => api.post(`/api/admin/ai/psych/recompute/${encodeURIComponent(userId)}`, data),

  seedDemoPsychData: (data = {}) => api.post('/api/admin/ai/demo/seed', data),

  clearDemoPsychData: (data = {}) => api.post('/api/admin/ai/demo/clear', data),

};



export default api;
